import { API } from "../config/config";

const StatsService = {
  getSalesStats: (storeId, params) => getSalesStats(storeId, params),
  getExpensesStats: (storeId, params) => getExpensesStats(storeId, params),
  getExpenses: (storeId, params) => getExpenses(storeId, params),
};

const getSalesStats = async (storeId, params = {}) => {
  try {
    const queryParams = new URLSearchParams();
    
    if (params.start_date) queryParams.append('start_date', params.start_date);
    if (params.end_date) queryParams.append('end_date', params.end_date);
    if (params.status) queryParams.append('status', params.status);
    
    const queryString = queryParams.toString();
    const url = `/stores/${storeId}/sales/stats${queryString ? `?${queryString}` : ''}`;
    
    var response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

const getExpensesStats = async (storeId, params = {}) => {
  try {
    if (!storeId) {
      throw new Error('storeId is required for expenses stats');
    }

    const queryParams = new URLSearchParams();

    const dateFrom = params.date_from || params.start_date;
    const dateTo = params.date_to || params.end_date;

    if (dateFrom) {
      queryParams.append('date_from', dateFrom);
      queryParams.append('start_date', dateFrom);
    }
    if (dateTo) {
      queryParams.append('date_to', dateTo);
      queryParams.append('end_date', dateTo);
    }
    if (params.include_revenue !== undefined) queryParams.append('include_revenue', String(params.include_revenue));
    if (params.q !== undefined && params.q !== '') queryParams.append('q', params.q);

    const queryString = queryParams.toString();
    const url = `/stores/${storeId}/movements/expenses/stats${queryString ? `?${queryString}` : ''}`;

    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

const getExpenses = async (storeId, params = {}) => {
  try {
    if (!storeId) throw new Error('storeId is required');

    const queryParams = new URLSearchParams();

    if (params.date_from) queryParams.append('date_from', params.date_from);
    if (params.date_to) queryParams.append('date_to', params.date_to);
    if (params.q) queryParams.append('q', params.q);
    if (params.page) queryParams.append('page', String(params.page));
    if (params.page_size) queryParams.append('page_size', String(params.page_size));
    if (params.sort_by) queryParams.append('sort_by', params.sort_by);
    if (params.sort_order) queryParams.append('sort_order', params.sort_order);

    const queryString = queryParams.toString();
    const url = `/stores/${storeId}/movements/expenses${queryString ? `?${queryString}` : ''}`;

    const response = await API.get(url);
    return response.data;
  } catch (err) {
    console.error('Error:', err);
    throw new Error(err);
  }
};

export default StatsService;